import { tss } from 'tss-react';
import React from 'react';
import styles from "./styles";
import Link from "@mui/material/Link";
import Button from "@mui/material/Button";

import RailsRoutes from '../Shared/RailsRoutes';
import WebsaUITheme from '../Shared/WebsaUITheme';
import ThemeProvider from '../Shared/ThemeProvider';
import Copyright from "../Shared/Copyright/Copyright";
import LogoHeader from "../Shared/LogoHeader/LogoHeader";
import Slider from "../Shared/Slider/Slider";

export default function Services(props) {
  const theme = ThemeProvider(props.theme);
  const { classes } = tss.create(styles(theme))();

  return (
    <WebsaUITheme theme={props.theme}>
      <div className={classes.root}>
        <LogoHeader/>
        <div className={classes.slider}>
          <Slider/>
        </div>
        <div className={classes.form}>
          <div className={classes.head}>
            <p>
              Sign in as a different user? <Link rel="stylesheet" data-method="DELETE" href={RailsRoutes.destroy_user_session_path()}>Sign out</Link>
            </p>
          </div>
          <div className={classes.tagForm}>
            <div className={classes.root}>
              <div className={classes.loginForm}>
                <h3 className={classes.infoBlockTitle}>
                  Hello, {props.username}
                  <p className={classes.infoBlockDescription}>
                    You can use these panels to manage Websa applications:
                  </p>
                </h3>
                <div className={classes.buttonLinkContainer}>
                  {
                    props.admin_panels.map(panel => {
                      return (
                        <div>
                          <Button variant="outlined" color="primary" href={panel.uri}>
                            {panel.name}
                          </Button>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            </div>
          </div>
          <Copyright/>
        </div>
      </div>
    </WebsaUITheme>
  );
}
